import { useState, useEffect, useCallback } from 'react';
import api from '../lib/api';

export function useIdeas(filters = {}) {
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchIdeas = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.status) params.status = filters.status;
      if (filters.search) params.search = filters.search;
      const res = await api.get('/ideas/', { params });
      setIdeas(res.data.results || res.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to load ideas');
    } finally {
      setLoading(false);
    }
  }, [filters.status, filters.search]);

  useEffect(() => {
    fetchIdeas();
  }, [fetchIdeas]);

  const createIdea = async (rawInput) => {
    const res = await api.post('/ideas/', { raw_input: rawInput });
    setIdeas((prev) => [res.data, ...prev]);
    return res.data;
  };

  const deleteIdea = async (id) => {
    await api.delete(`/ideas/${id}/`);
    setIdeas((prev) => prev.filter((i) => i.id !== id));
  };

  return { ideas, loading, error, fetchIdeas, createIdea, deleteIdea };
}
